import {Modal, List, Typography} from 'antd';
import {useState} from 'react';

interface FirmSelectorModalProps {
    firms: any[];
    open: boolean;
    onSelect: (firm: any) => void;
    onCancel: () => void;
}

const FirmSelectorModal = ({firms, open, onSelect, onCancel}: FirmSelectorModalProps) => {
    const [selected, setSelected] = useState<number | null>(null);

    return (
        <Modal
            title="Sélectionnez une firme"
            open={open}
            onCancel={onCancel}
            onOk={() => selected !== null && onSelect(firms[selected])}
            okButtonProps={{disabled: selected === null}}
        >
            <List
                bordered
                dataSource={firms}
                renderItem={(item, index) => (
                    <List.Item
                        style={{
                            background: selected === index ? 'var(--g-color-base-selection)' : undefined,
                            cursor: 'pointer'
                        }}
                        onClick={() => setSelected(index)}
                    >
                        <Typography.Text strong>{item.name}</Typography.Text>
                    </List.Item>
                )}
            />
        </Modal>
    );
};

export default FirmSelectorModal;
